//Yup and Formik are used for validations
import * as yup from "yup";
export const validationSchema = yup.object({
  email: yup
    .string()
    .required("email is required")
    .email("Please enter a valid email"),
  password: yup.string().required("Password is required"),
});
